import React from 'react'
import './TopBar.css'
import logo from '../images/logoN.svg'
import { Link } from 'react-router-dom'
import { useGetMeQuery } from '../../redux/services/users'
const TopBar = () => {
    const { data: user } = useGetMeQuery();
    return (
        <header>
            <div className="container u-full-width u-max-full-width">
                <div className="row">
                    <div className="six columns">
                        <Link to='/' className="logo u-pull-left" >
                            <img src={logo} alt='' />
                        </Link>
                    </div>
                    <div className="six columns">
                        <Link to='/account' style={{ textDecoration: 'none' }} className="user-d u-pull-right">
                            <div className="img">{user?.full_name?.charAt(0)?.toUpperCase()}</div>
                            <div className="u-name">
                                <strong>{user?.organization?.name}</strong>
                                {user?.full_name}
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default TopBar